import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import TextFields from "../UI/TextField-f";
import SwitchToggle from "../UI/SwitchToggle";
import Breadcrumb from "../UI/Breadcrumb";
import Dialog from "../UI/Dialog";
import imgPlaceholder from "../../assets/img/img-placeholder.png";

import { Formik, Form } from "formik";
import * as yup from "yup";
import SearchForm from "../UI/SearchForm";
import Pagination from "../UI/Pagination";
import DeactivateDialog from "./DeactivateDialog";
import PromptDialog from "./PromptDialog";

import { getItems, editItem } from "../../actions";

const mandatoryErrorMessage = "This field is mandatory.";
const numbersErrorMessage = "Valid characters include 0-9.";
const validateIsOnlyNumbersAndDot = value => {
  const regex = /^[0-9.]+$/g;
  if (!value || regex.test(value)) {
    return true;
  }
  return false;
};

class CustomerMenuListItem extends Component {
  state = {
    page: 1,
    searchedValue: null,
    isDialogOpen: false,
    isDeactivateDialogOpen: false,
    isCancelDeactivationDialogOpen: false,
    isDeletingDialogOpen: false,
    selectedItemId: null
  };

  componentDidMount() {
    const { menuId } = this.props.match.params;
    const { page, searchedValue } = this.state;
    this.props.getItems(menuId, page, searchedValue);
  }

  onSubmitDeactivateStatusHandler = values => {
    if (
      values.deactivate &&
      values.deactivate === "deactivate_from" &&
      values.date
    ) {
      this.changeStatus(this.state.selectedItemId, false, values.date);
    } else {
      this.changeStatus(this.state.selectedItemId, false);
    }
    this.setState({ isDeactivateDialogOpen: false });
  };

  changeStatus = (itemId, status, date) => {
    const data = {};
    if (date) {
      data.deactivation_date = moment(date).format("YYYY-MM-DD");
    } else {
      data.is_active = status;
    }
    this.props.editItem(itemId, data).then(res => {
      const { listId } = this.props.match.params;
      this.props.getItems(listId, this.state.page, this.state.searchedValue);
    });
  };

  deleteItem = () => {
    const data = { is_deleted: true };
    this.props.editItem(this.state.selectedItemId, data).then(res => {
      const { listId } = this.props.match.params;
      this.props.getItems(listId, this.state.page, this.state.searchedValue);
    });
    this.setState({ isDeletingDialogOpen: false, selectedItemId: null });
  };

  cancelDeactivation = () => {
    const data = { deactivation_date: null };
    this.props.editItem(this.state.selectedItemId, data).then(res => {
      const { listId } = this.props.match.params;
      this.props.getItems(listId, this.state.page, this.state.searchedValue);
    });
    this.setState({
      isCancelDeactivationDialogOpen: false,
      selectedItemId: null
    });
  };

  onSubmitChangePriceHandler = value => {
    if (value.hasOwnProperty("price")) {
      const data = {
        id: this.state.selectedItemId,
        price: value.price
      };
      this.props.editItem(this.state.selectedItemId, data).then(res => {
        this.props.getItems(
          this.props.match.params.listId,
          this.state.page,
          null
        );
      });
    }
    this.setState({ isDialogOpen: false });
  };

  onSubmitSearchHandler = searchValue =>
    this.props.getItems(this.props.match.params.listId, 1, searchValue);

  openDeactivateDialog = (itemId, isActive) => {
    if (isActive) {
      this.setState({ isDeactivateDialogOpen: true, selectedItemId: itemId });
    } else {
      this.changeStatus(itemId, true);
    }
  };

  renderItems = () => {
    let items = null;
    const { data } = this.props;
    if (data && data.items && data.result) {
      items = data.result.map(itemId => {
        const item = data.items[itemId];
        let deactivationDate = null;
        if (item.deactivationDate) {
          deactivationDate = (
            <p>
              <span className="color-grey50">Deactivated from: </span>
              <span className="color-primary ml-5">
                {item.deactivationDate}
              </span>
            </p>
          );
        }
        return (
          <li key={item.id} className="card pointer">
            <div
              className="inner with-top"
              onClick={() =>
                this.setState({ isDialogOpen: true, selectedItemId: item.id })
              }
            >
              <div className="inner-top">{deactivationDate}</div>
              <div>
                <h2>{item.name}</h2>
                <p>{item.price} SAR</p>
              </div>
            </div>
            <div className="options text-center flex-center-y justify-between">
              <p>Item Status</p>
              <div
                onClick={() =>
                  this.openDeactivateDialog(item.id, item.isActive)
                }
              >
                <SwitchToggle notForm toggled={item.isActive} />
              </div>
            </div>
            <div className="action">
              {item.deactivationDate && (
                <Link
                  to="#"
                  onClick={() =>
                    this.setState({
                      isCancelDeactivationDialogOpen: true,
                      selectedItemId: item.id
                    })
                  }
                >
                  <span className="cancel">&#10006;</span>
                </Link>
              )}
              {/* <Link
                to="#"
                onClick={() =>
                  this.setState({
                    isDeletingDialogOpen: true,
                    selectedItemId: item.id
                  })
                }
                className="color-red"
              >
                <span className="trash fa fa-trash" />
              </Link> */}
            </div>
          </li>
        );
      });
    }
    return items;
  };

  pageChangeHandler = page =>
    this.props.getItems(
      this.props.match.params.listId,
      page.selected + 1,
      null
    );

  render() {
    let pagination = null;
    if (
      this.props.data &&
      this.props.data.pageCount &&
      this.props.data.pageCount > 1
    ) {
      pagination = (
        <Pagination
          pageChangeHandler={this.pageChangeHandler}
          pageCount={this.props.data.pageCount}
        />
      );
    }
    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9 text-left">
                <h1 className="color-grey">Item List</h1>
              </div>
              <SearchForm onSubmit={this.onSubmitSearchHandler} />
            </div>
          </div>
        </div>
        <div className="container">
          <Breadcrumb
            from={[
              { link: "/menu", label: "Menu Settings" }
            ]}
            current="Item"
          />
        </div>
        <div className="container inner-padding box py-15">
          <div className="box-body">
            {/* START: Card Items Container */}
            <ul className="card-items large">{this.renderItems()}</ul>
            {/* END: Card Items Container */}
            {pagination}
          </div>
        </div>

        <Dialog
          open={this.state.isDialogOpen}
          handleClose={() => this.setState({ isDialogOpen: false })}
        >
          {this.props.data &&
            this.state.selectedItemId && (
              <Formik
                initialValues={{
                  price: this.props.data.items[this.state.selectedItemId]
                    ? this.props.data.items[this.state.selectedItemId].price
                    : ""
                }}
                validationSchema={yup.object().shape({
                  price: yup
                    .string()
                    .required(mandatoryErrorMessage)
                    .test(
                      "name",
                      numbersErrorMessage,
                      validateIsOnlyNumbersAndDot
                    )
                })}
                onSubmit={this.onSubmitChangePriceHandler}
                render={({
                  values,
                  touched,
                  setFieldValue,
                  handleChange,
                  handleSubmit,
                  handleBlur,
                  errors,
                  dirty
                }) => (
                  <Form>
                    <div className="popup-body">
                      <div className="flex">
                        <div className="image-upload size-md my-20">
                          <div className="image">
                            {/* START: Replace this image after upload */}
                            <img
                              src={
                                this.props.data.items[this.state.selectedItemId]
                                  .image
                                  ? this.props.data.items[
                                      this.state.selectedItemId
                                    ].image
                                  : imgPlaceholder
                              }
                              alt="placeholder"
                            />
                            {/* END: Replace this image after upload */}
                          </div>
                        </div>
                        <ul className="ml-50 mt-10 w-700">
                          <li className="py-15">
                            <p className="font-sm color-grey50">Name</p>
                            <p className="color-primary mt-5">
                              {
                                this.props.data.items[this.state.selectedItemId]
                                  .name
                              }
                            </p>
                          </li>
                          <li className="py-15">
                            <p className="font-sm color-grey50">Price</p>
                            <TextFields
                              value={values.price}
                              name="price"
                              type="text"
                              error={touched.price && errors.price}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              hintText="Price"
                            />
                          </li>
                        </ul>
                      </div>
                      <div className="py-15 w-700">
                        <p className="font-sm color-grey50">Description</p>
                        <p className="color-primary mt-5">
                          {
                            this.props.data.items[this.state.selectedItemId]
                              .description
                          }
                        </p>
                      </div>
                      <div className="popup-meta flex justify-end">
                        <button
                          type="submit"
                          className="btn filled primary min-120"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              />
            )}
          <button
            className="no-style close-btn"
            onClick={() => this.setState({ isDialogOpen: false })}
          >
            ×
          </button>
        </Dialog>

        <DeactivateDialog
          open={this.state.isDeactivateDialogOpen}
          close={() => this.setState({ isDeactivateDialogOpen: false })}
          onSubmitDialog={this.onSubmitDeactivateStatusHandler}
        />

        <PromptDialog
          open={this.state.isCancelDeactivationDialogOpen}
          prompt={"Are you sure you want to cancel the deactivation?"}
          close={() => this.setState({ isCancelDeactivationDialogOpen: false })}
          changeStatus={this.cancelDeactivation}
        />

        <PromptDialog
          open={this.state.isDeletingDialogOpen}
          prompt={"Are you sure you want to delete the list?"}
          close={() => this.setState({ isDeletingDialogOpen: false })}
          changeStatus={this.deleteItem}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.foodna
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getItems: (listId, page, searchValue) =>
      dispatch(getItems(listId, page, searchValue)),
    editItem: (id, data) => dispatch(editItem(id, data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerMenuListItem);



// WEBPACK FOOTER //
// ./src/components/Customer-web-portal/Item.js